import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';
import { IProfileData } from '@intigral/types';

export interface IUpdateProfileUseCase {
    execute(
        apiKey: string,
        guid: string,
        password: string,
        profileName: string,
        updatedProfileSettings: any,
        kidsMode: boolean,
        token: string,
        authSign: string,
        identityToken: string,
        currentProfile: IProfileData,
        apiToken: { [key: string]: string }
    ): Promise<any>;
}

export class UpdateProfileUseCase implements IUpdateProfileUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        guid: string,
        password: string,
        profileName: string,
        updatedProfileSettings: any,
        kidsMode: boolean,
        token: string,
        authSign: string,
        identityToken: string,
        currentProfile: IProfileData,
        apiToken: { [key: string]: string }
    ): Promise<any> {
        const profile = await this.profileRepository.updateProfile(
            apiKey,
            guid,
            password,
            profileName,
            updatedProfileSettings,
            kidsMode,
            token,
            authSign,
            identityToken,
            currentProfile,
            apiToken
        );
        return profile.data;
    }
}
